import { render } from "./BusinessInvoice_profit_loss_fixed.vue?vue&type=template&id=5e531607&scoped=true"
import script from "./BusinessInvoice_profit_loss_fixed.vue?vue&type=script&lang=js"
export * from "./BusinessInvoice_profit_loss_fixed.vue?vue&type=script&lang=js"

import "./BusinessInvoice_profit_loss_fixed.vue?vue&type=style&index=0&id=5e531607&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e531607"]])

export default __exports__